import { type SVGComponentProps } from '@v2/ui/Icon/Template';
import { Country, HipHop, Pop, RAndB, Rock } from '@v2/ui/Icon/concerts';
import { FC } from 'react';
import { SONG_CATEGORY } from './concertCategories';

type GenreDropdownIconsProps = SVGComponentProps & {
  genre: SONG_CATEGORY;
  isSelected: boolean;
};

const iconByGenre: Record<SONG_CATEGORY, FC<SVGComponentProps>> = {
  POP: Pop,
  ALTERNATIVE_ROCK: Rock,
  DANCE_ELECTRONIC: HipHop,
  COUNTRY_FOLK: Country,
  RAP_HIPHOP: RAndB,
  HARD_ROCK_METAL: Rock,
};

export const GenreDropdownIcons = ({
  genre,
  isSelected,
  ...props
}: GenreDropdownIconsProps) => {
  const Icon = iconByGenre[genre];
  return <Icon {...props} stroke={isSelected ? '#FA2846' : '#1D2939'} />;
};
